
import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
    name: 'HomeAthleteReviews',
    components: {Swiper, SwiperSlide},
    props: {
        reviews: {type: Array, required: true},
    },
    data() {
        return {
            snapCount: null,
            atBeginning: true,
            atEnd: false,
        };
    },
    computed: {
        swiperOptions() {
            return {
                preloadImages: false,
                slidesPerView: 1,
                spaceBetween: 12,
                watchOverflow: true,
                keyboard: {enabled: true, onlyInViewport: true},
                scrollbar: {
                    el: '.home-athletes__scrollbar',
                    draggable: true,
                    dragSize: 56,
                    hide: false,
                },
                breakpoints: {1024: {slidesPerView: Math.min(2, this.visibleReviews.length) || 1, spaceBetween: 0, scrollbar: {dragSize: 100}}},
            };
        },
        visibleReviews() {
            return this.reviews.filter(review => this.getImage(review, 'small'));
        },
        pageCount() {
            return this.snapCount === null ? this.visibleReviews.length : this.snapCount;
        },
    },
    watch: {
        visibleReviews() {
            this.$nextTick(() => {
                const swiper = this.getSwiper();
                if (!swiper || swiper.destroyed) return;
                // The desktop view becomes full width when only one review remains.
                const slidesPerView = Math.min(2, this.visibleReviews.length) || 1;
                swiper.params.breakpoints[1024].slidesPerView = slidesPerView;
                swiper.originalParams.breakpoints[1024].slidesPerView = slidesPerView;
                if (swiper.currentBreakpoint === '1024') swiper.params.slidesPerView = slidesPerView;
                swiper.update();
                this.updateNavigation();
            });
        },
    },
    methods: {
        getImage(review, size) {
            return review.image && ((review.image.sizes && review.image.sizes[size]) || review.image.path);
        },
        getSrcset(review) {
            const sizes = review.image && review.image.sizes;
            return sizes && sizes.small && sizes.big ? `${sizes.small} 640w, ${sizes.big} 1280w` : null;
        },
        formatHandle(handle) {
            const value = handle.trim();
            return value && !value.startsWith('@') ? `@${value}` : value;
        },
        getSwiper() {
            return this.$refs.reviewsSwiper && this.$refs.reviewsSwiper.$swiper;
        },
        updateNavigation() {
            this.$nextTick(() => {
                const swiper = this.getSwiper();
                if (swiper && !swiper.destroyed) {
                    const hadArrows = this.pageCount > 1;
                    this.snapCount = swiper.isLocked ? 1 : swiper.snapGrid.length;
                    this.atBeginning = swiper.isBeginning || swiper.isLocked;
                    this.atEnd = swiper.isEnd || swiper.isLocked;
                    // Swiper handles normal movement and resizing itself. Only
                    // adding/removing the arrow group changes the track after render.
                    if (hadArrows !== (this.pageCount > 1)) {
                        this.$nextTick(() => {
                            if (!swiper.destroyed && swiper.scrollbar) {
                                swiper.scrollbar.updateSize();
                                swiper.scrollbar.setTranslate();
                            }
                        });
                    }
                }
            });
        },
        slidePrev() {
            const swiper = this.getSwiper();
            if (swiper) swiper.slidePrev();
        },
        slideNext() {
            const swiper = this.getSwiper();
            if (swiper) swiper.slideNext();
        },
    },
}
